import herobanner from "../assets/images/banner-img.jpeg"
import "./HeroBanner.css";

const HeroBanner = () => {
    return(
        <section className="hero-banner">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 p-0">
                        <div className="hero-banner-img">
                            <img className="img-fluid" src={herobanner} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroBanner;